<img class="item-image" 
    *ngIf="item.pictures.length > 0" 
    [src]="picturesUrl + '/' + item.pictures[0].key"/>
<mat-icon fontSet="material-symbols-outlined" *ngIf="item.pictures.length === 0" class="item-image">{{item.fillerIconName}}</mat-icon>